import styles from './Textarea.module.scss';
import FormElement from '../FormElement';
import { forwardRef, useEffect, useRef } from 'react';

const TextareaComponent = forwardRef(({ value, onChange, label, desc }, ref) => {
    const inputRef = useRef(null);
    const onKeyDown = (e) => {
        if (e.keyCode === 32) {
            e.preventDefault();
        } else if (e.keyCode === 13 && value && !e.shiftKey) {
            ref?.current?.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }))
        }
    };

    // resize
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.style.height = '5px';
            inputRef.current.style.height = (inputRef.current.scrollHeight) + 'px';
        }
    }, [value]);

    return (
        <FormElement label={label} desc={desc}>
            <textarea className={styles.redlTextarea} onChange={onChange} value={value} onKeyDown={onKeyDown}
                      ref={inputRef} />
        </FormElement>
    );
});

TextareaComponent.displayName = 'TextareaComponent';
export default TextareaComponent;